import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';

var Icon = styled("img")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  border-radius: 50%;\n"], ["\n  ", "\n  border-radius: 50%;\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: ".concat(size, "px;\n    height: ").concat(size, "px;\n  ");
});
var Placeholder = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #324054;\n  font-size: 16px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #324054;\n  font-size: 16px;\n"])));
var templateObject_1, templateObject_2;

export { Icon, Placeholder };
